import React from 'react'
import DriverPaymentList from "./DriverPaymentList"

const DriverPaymentTab = () => {
  return (
    <DriverPaymentList/>
  )
}

export default DriverPaymentTab